import { CUSTOMER_VERIFICATION, CUSTOMER_VERIFICATION_SUCCESS, CUSTOMER_VERIFICATION_ERROR, CUSTOMER_VERIFICATION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CustomerVerification = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_VERIFICATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CUSTOMER_VERIFICATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CUSTOMER_VERIFICATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CUSTOMER_VERIFICATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CustomerVerification;
